import { RepositoryFactory } from '@/api/RepositoryFactory'
import { arrToObj } from '@/helpers/functions'

const LibRepository = RepositoryFactory.get('libs')
const SET_ALL_LIBS = 'SET_ALL_LIBS'
const libs = [
  { field: 'loadTypes', nameLib: 'способы погрузки' },
  { field: 'freightTypes', nameLib: 'типы груза' },
]

export default {
  namespaced: true,
  state: {
    loadTypes: [],
    freightTypes: [],
  },
  getters: {
    checkLibs: state => state.loadTypes.length && state.freightTypes.length,
    getLib: state => lib => state[lib] || [],
    getLibObj:
      state =>
      (lib, field = 'name') =>
        arrToObj(state[lib], field),
  },
  actions: {
    setLibs(context) {
      libs.map(l => {
        const { nameLib, field } = l

        LibRepository.get('', { params: { nameLib } }).then(response => {
          context.commit(SET_ALL_LIBS, { data: response.data, field })
        })
      })
    },
  },
  mutations: {
    [SET_ALL_LIBS](state, { data, field }) {
      state[field] = data.data
    },
  },
}
